/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var MiscellaneousMeetingStatus;

(function (MiscellaneousMeetingStatus) {
  MiscellaneousMeetingStatus["NOT_REQUIRED"] = "not_required";
  MiscellaneousMeetingStatus["TO_BE_SCHEDULED"] = "to_be_scheduled";
  MiscellaneousMeetingStatus["BOOKED"] = "booked";
  MiscellaneousMeetingStatus["COMPLETED"] = "completed";
  MiscellaneousMeetingStatus["RESCHEDULED"] = "rescheduled";
  MiscellaneousMeetingStatus["CANCELLED"] = "cancelled";
})(MiscellaneousMeetingStatus || (MiscellaneousMeetingStatus = {}));